<template>
    <div class="padding text-center fw-bold">
        <b-modal id="multilocations-modal" v-model="modalVisible">
            <div>
                <h3>{{ $t('multilocation.modal.title') }}</h3>
                
                <div v-if="locations.length > 5" class="mb-1 mt-1">
                    {{ $t('multilocation.zipcode_search') }}:
                    <input type="text" v-model="zipSearchModel" placeholder="97082">

                    <hr>
                </div>

                <div v-for="location in getLocations" style="margin-bottom: 5px;">
                    {{ location.zip_code }} {{ location.city }} {{ location.street }} {{ location.house_number }}
                </div>
            </div>
        </b-modal>

        <font-awesome-icon icon="far fa-location" /> <b>{{ $t('multilocation.on_locations', { count: locations.length }) }}</b>

        <div class="padding">
            <div v-for="location in locations.slice(0, 4)" :key="location.id" class="small">
                {{ location.zip_code }} {{ location.city }} {{ location.street }} {{ location.house_number }}
            </div>

            <div class="small text-muted text-center mt-1" style="cursor: pointer;" @click="modalVisible = true">
                {{ $t('pds.complete_equipment.show_more') }}
            </div>
        </div>
    </div>
</template>

<script>
import { BModal } from "bootstrap-vue";

export default {
    name: 'Multilocations',

    components: { BModal },

    props: {
        locations: {
            type: Array
        }
    },
    
    data() {
        return {
            modalVisible: false,
            zipSearchModel: '',
        }
    },

    computed: {
        getLocations() {
            if (!this.zipSearchModel) {
                return this.locations
            }

            return this.locations.filter((item) => item.zip_code.startsWith(this.zipSearchModel))
        }
    },
}
</script>

<style scoped>
.padding {
    padding: 20px;
}
</style>